export const REFERRAL_REDIRECT_WHITELIST = ['/', '/mfa-setup'];
